import React, { FunctionComponent, MouseEvent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { FlagColor, MouseButton } from "@multiweb/types/react";

export type FlagCircleProps = {
    /** Název barvy flagu typu FlagColor */
    color: FlagColor;
    /** Popis barvy */
    title?: string;
    /** Příznak značící, jestli je daný flag vybrán */
    isSelected?: boolean;
    /** Callback volaný při změně */
    onChange?: (color: FlagColor, checked: boolean) => void;
};

const classNames = bemClassNames("flag-circle-component");

/** Klikatelné barevné kolečko flagu */
export const FlagCircle: FunctionComponent<FlagCircleProps> = ({ color, title, isSelected, onChange }) => {
    const updateColor = (color: FlagColor): any => {
        return { "--flag-circle-color": color };
    };

    const onClick = (event: MouseEvent) => {
        if (event.button == MouseButton.leftButton && onChange) {
            onChange(color, !isSelected);
        }
    };
    return (
        <div
            className={classNames()}
            {...{ onClick, title }}
            data-color={color}
            data-checked={isSelected}
            style={updateColor(color)}
        >
        </div>
    );
};
